interface FeatureConfig {
    enabled: boolean;
    [key: string]: string | boolean | number;
}

interface SetupConfig {
    [key: string]: string | boolean;
}

interface SiteConfig {
    skin: string;
    setup: SetupConfig;
    features: FeatureConfig[];
}

interface ConfigSites {
    [key: string]: SiteConfig;
}

export const configDefault: ConfigSites = {
    default: {
        skin: "orange",
        setup: {
            apiUrl: "https://dev-phandabets-retail.bitville.dev/cms",
            isTestingBrowers: true,
            appName: "Sports betting",
            logo: "https://dev-phandabets-retail.bitville.dev/sites/Retail/images/phandabets_logo.png",
            logoPrint:
                "https://dev-phandabets-retail.bitville.dev/print/logo-phandabets.jpg",
        },
        features: [
            {
                enabled: true,
                name: "sports",
                icon: "sports",
                routing: "/sports",
                hasIcon: false,
                hasBanner: true,
                img: "",
                col: 1,
                isGame: true,
                code: "S",
            },
            {
                enabled: true,
                name: "number",
                icon: "number",
                routing: "/number",
                hasIcon: false,
                hasBanner: true,
                img: "",
                col: 1,
                isGame: true,
                code: "N",
            },
            {
                enabled: true,
                name: "history",
                icon: "history",
                routing: "/history",
                hasIcon: true,
                hasBanner: false,
                img: "",
                col: 2,
                ticketWillShow: 5,
                hasComponent2: false,
            },
            {
                enabled: true,
                name: "scan",
                icon: "scan",
                routing: "/scan",
                hasIcon: true,
                hasBanner: false,
                img: "",
                col: 2,
                isOnlyPaument: false,
            },
            {
                enabled: true,
                name: "report",
                icon: "report",
                routing: "/report",
                hasIcon: true,
                hasBanner: false,
                img: "",
                col: 2,
                config5: "value5",
            },
            {
                enabled: true,
                name: "report final",
                icon: "report",
                routing: "/report-final",
                hasIcon: true,
                hasBanner: false,
                img: "",
                col: 2,
                config5: "value5",
            },
            {
                enabled: true,
                name: "print",
                icon: "print",
                routing: "/print",
                hasIcon: true,
                hasBanner: false,
                img: "",
                col: 1,
                config6: "value6",
                config7: "value7",
            },
        ],
    },
};
